import ToggleableButton from "../../../../../components/toggleableButton/toggleableButton";
import { connect } from "react-redux";
import { actionCreators } from "../redux/sagas/packagesSales/packagesSales";

export default connect(
  state => ({
    isActive: state.packagesSales.selectedFilters.only_challengers,
    isRadio: true,
    title: "only-challengers"
  }),
  { onClick: data => actionCreators.updateOnlyChallengers(data) }
)(ToggleableButton);